module.exports = __webpack_public_path__ + "imgs/letape2.e619ab0a.webp";